import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ArrowLeft } from "lucide-react";
import { resolveBreadcrumbs } from "../../helpers/breadcrumbs/resolveBreadcrumbs";

// Ruta de la página en la barra superior (solo escritorio, ver
// .hl-topbar-context): botón para subir un nivel y la ruta en una línea, con
// la página actual en negrita (el título grande ya está en la página). En el inicio no hay a dónde volver, así que
// saluda, como el panel de referencia ("Hola, Edwins").
//
// En tablet y móvil sigue la barra pegajosa de Breadcrumbs.jsx, que además
// pliega niveles intermedios; las dos se arman con resolveBreadcrumbs.
const TopbarCrumbs = () => {
  const { pathname, state } = useLocation();
  const user = useSelector((store) => store.auth?.user);
  const crumbs = resolveBreadcrumbs(pathname, { role: user?.role, state });

  if (crumbs.length < 2) {
    const firstname = user?.firstname || user?.name;
    return (
      <div className="hl-crumbs">
        <div className="hl-crumbs__current hl-crumbs__current--hero">
          {firstname ? `Hola, ${firstname}` : crumbs[0]?.label || "Inicio"}
        </div>
      </div>
    );
  }

  const parent = crumbs[crumbs.length - 2];
  const current = crumbs[crumbs.length - 1];

  return (
    <nav className="hl-crumbs" aria-label="Ruta de navegación">
      <Link
        to={{ pathname: parent.to, state }}
        className="hl-icon-button hl-crumbs__back"
        title={`Volver a ${parent.label}`}
        aria-label={`Volver a ${parent.label}`}
      >
        <ArrowLeft size={18} strokeWidth={1.75} aria-hidden="true" />
      </Link>
      <ol className="hl-crumbs__trail">
        {crumbs.slice(0, -1).map((crumb) => (
          <li key={crumb.key} className="hl-crumbs__parent">
            <Link to={{ pathname: crumb.to, state }}>{crumb.label}</Link>
          </li>
        ))}
        <li className="hl-crumbs__current" aria-current="page">
          {current.label}
        </li>
      </ol>
    </nav>
  );
};

export default TopbarCrumbs;
